import { ScanApiConstant } from '../actionTypes/scan.constant';
import axios from 'axios';
import { delay, put, call, take, race} from 'redux-saga/effects'

function* pollLiveView(id) {
    while (true) {
      try {
        let liveViewUrl = '/devices/' + id + '/get_live_image';
        const { data } = yield call(() => axios({ url: liveViewUrl }));
        yield put(updateLiveView(data));
        yield delay(100);
      } catch (err) {
        yield put(failedToUpdateLiveView(err));
      }
    }
}

export const watchPollLiveView = function* (id) {
	while (true) {
  	yield take(ScanApiConstant.START_LIVE_VIEW);
    yield race([
      call(pollLiveView, id),
      take(ScanApiConstant.STOP_LIVE_VIEW)
    ]);
  }
}

export const updateLiveView = (data) => ({
    type: ScanApiConstant.UPDATE_LIVE_VIEW,
    data: data,
})

export const failedToUpdateLiveView = (err) => ({
    type: ScanApiConstant.FAILED_IN_LIVE_VIEW_UPDATE,
    err: err,
})

export const startLiveView = () => ({
  type : ScanApiConstant.START_LIVE_VIEW
})

export const stopLiveView = () => ({
  type : ScanApiConstant.STOP_LIVE_VIEW
})